import styled from "styled-components"
import ProgressStep from "./ProgressStep"
import { Step } from "./types"

interface Props {
  steps: Step[]
  currentStep: number
  currentOptions: number
  expandedStep: number
  active: number
  expanded: number
  handleOptionChange: (option: number) => void
  handleStepChange: (stepIndex: number) => void
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  max-width: 100%;
  width: 100%;
  padding: 10px 15px 0 15px;
  align-items: center;
  font-family: "Jost", sans-serif;

  @media (max-width: 500px) {
    width: 100vw;
  }
`
const InnerContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  max-width: 100%;
  position: relative;
  gap: 50px;

  &:before {
    content: "";
    position: absolute;
    top: 35%;
    left: 0;
    width: 95%;
    height: 4px;
    background: gray;
    z-index: 1;
  }

  @media (max-width: 500px) {
    max-width: 100%;
    gap: 18px;
    overflow-x: auto;

    &:before {
      content: "";
      position: absolute;
      top: 35%;
      left: 8%;
      width: ${(props) => (props.isExpanded ? "100%" : "80%")};
      height: 4px;
      background: gray;
      z-index: 1;
    }
  }

  @media (min-width: 768px) {
    max-width: 100%;
    gap: 30px;
  }
`

export default function ProgressBar({
  steps,
  active,
  expanded,
  currentOptions,
  currentStep,
  expandedStep,
  handleOptionChange,
  handleStepChange,
}: Props) {
  const isSummaryStep = steps[currentStep].label !== "Summary"
  return (
    <Container>
      <InnerContainer isExpanded={isSummaryStep}>
        {steps.map((step, index) => (
          <ProgressStep
            key={index}
            step={step}
            currentOption={currentOptions}
            isCurrentStep={index === currentStep}
            isCurrentStepActive={index === active}
            isCurrentStepExpand={index === expanded}
            isExpanded={index === expandedStep}
            handleOptionChange={handleOptionChange}
            onStepChange={() => handleStepChange(index)}
          />
        ))}
      </InnerContainer>
    </Container>
  )
}
